const home = '';
const mobileApp = '/app';
const projects = '/projects';
const orders = '/orders';
const invoices = '/invoices';
const users = '/users';
const userDetails = '/users/:id';
const projectDetails = '/projects/:id';
const orderDetails = '/orders/:id';
const boxDetails = '/projects/:id/box/:boxid';
const login = '/login';
const register = '/register';
const support = '/support';
const privacy = '/privacy';
const requestAccountDeletion = '/request-account-deletion';
const accountDetails = '/account';
const acceptAccount = '/account/accept';
const resetPassword = '/account/resetpass';
const emailAction = '/email-action';

import Home from '@/components/Home.vue';
import MobileApp from '@/components/MobileApp.vue';
import Projects from '@/components/Projects.vue';
import Orders from '@/components/Orders.vue';
import Invoices from '@/components/Invoices.vue';
import Users from '@/components/Users.vue';
import UserDetails from '@/components/DetailsUser.vue';
import ProjectDetails from '@/components/DetailsProject.vue';
import OrderDetails from '@/components/DetailsOrder.vue';
import BoxDetails from '@/components/DetailsBox.vue';
import Login from '@/components/Login.vue';
import Register from '@/components/Register.vue';
import Support from '@/components/Support.vue';
import Privacy from '@/components/Privacy.vue';
import RequestAccountDeletion from '@/components/RequestAccountDeletion.vue';
import AccountDetails from '@/components/DetailsAccount.vue';
import AcceptAccount from '@/components/AcceptAccount.vue';
import ResetPassword from '@/components/ResetPassword.vue';
import EmailAction from '@/components/EmailAction.vue';

export const routes = [
  // More specific routes first to avoid being caught by catch-all
  { path: emailAction, component: EmailAction, name: 'EmailAction' },
  { path: mobileApp, component: MobileApp, name: 'App' },
  { path: projects, component: Projects, name: 'Projects' },
  { path: orders, component: Orders, name: 'Orders' },
  { path: invoices, component: Invoices, name: 'Invoices' },
  { path: users, component: Users, name: 'Users' },
  { path: userDetails, component: UserDetails, name: 'UserDetails' },
  { path: projectDetails, component: ProjectDetails, name: 'ProjectDetails' },
  { path: orderDetails, component: OrderDetails, name: 'OrderDetails' },
  { path: boxDetails, component: BoxDetails, name: 'BoxDetails' },
  { path: login, component: Login, name: 'Login' },
  { path: register, component: Register, name: 'Register' },
  { path: support, component: Support, name: 'Support' },
  { path: privacy, component: Privacy, name: 'Privacy' },
  {
    path: requestAccountDeletion,
    component: RequestAccountDeletion,
    name: 'RequestAccountDeletion',
  },
  { path: accountDetails, component: AccountDetails, name: 'AccountDetails' },
  { path: acceptAccount, component: AcceptAccount, name: 'AcceptAccount' },
  { path: resetPassword, component: ResetPassword, name: 'ResetPassword' },
  // Home route last as it's a catch-all empty path
  { path: home, component: Home, name: 'Home' },
  // Debug catch-all (remove after debugging)
  {
    path: '*',
    component: Home,
    beforeEnter: (to, from, next) => {
      console.log('Catch-all matched:', to.path, to);
      next();
    },
  },
];

export const paths = {
  home,
  mobileApp,
  projects,
  orders,
  invoices,
  users,
  userDetails,
  projectDetails,
  orderDetails,
  boxDetails,
  login,
  register,
  support,
  privacy,
  accountDetails,
  acceptAccount,
  resetPassword,
  emailAction,
  requestAccountDeletion,
};
